import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { format } from 'date-fns';
import QRCode from "react-qr-code";
import AppContext from "../context/AppContext";
import SignalsICO from "../assets/svg/signals-icon.svg";
import CTFSignalsLogo from "../assets/svg/ctxsignals-logo.png";
import EllipseGreen from "../assets/svg/ellipse/ellipse-green.svg"
import Chat from "../components/Chat";
import { useNavigate } from 'react-router-dom';
import LanguageAndNotificacions from "../components/LanguageAndNotificacions";
import toast from "react-hot-toast";

export default function Signals() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [wallet, setWallet] = useState();
  const [listDeposit, setListDeposit] = useState([]);
  const { loading, updateLoading } = useContext(AppContext);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(4)
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [signals, setSignals] = useState([]);
  const [isChatOpen, setIsChatOpen] = useState(false);  // Estado que controla la apertura y cierre del chat
  const [detailVisible, setDetailVisible] = useState({})

  const toggleChat = (item) => {
    setData(item)
    setIsChatOpen(!isChatOpen);  // Alternar el estado del chat
  };


  useEffect(() => {
    getAllSignals();
  }, [page, limit]);


  const getAllSignals = async () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/signals?page=${page}&limit=${limit}`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.status) {
          if (response.redirect) {
            navigate("/");
          }
        }
        console.log(response)
        setSignals(response?.data?.items)
        setTotal(response?.data?.total);
        updateLoading(false);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };

  const formatNumber = (value) => {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }

    const valueString = value.toString();
    const [integerPart, decimalPart] = valueString.split('.');

    // Si no hay parte decimal o no hay ceros desplazados, solo devolvemos el número original
    if (!decimalPart || decimalPart === '0') {
      return valueString;
    }

    // Contar los ceros iniciales en la parte decimal
    let leadingZeros = 0;
    while (decimalPart[leadingZeros] === '0') {
      leadingZeros++;
    }

    // Limitar a un máximo de 4 decimales o hasta que aparezca otro cero
    let limitDecimal = decimalPart.slice(leadingZeros); // Empieza con los decimales desplazados
    let nonZeroFound = false;

    // Recortar hasta 4 decimales o encontrar un cero
    for (let i = leadingZeros; i < decimalPart.length; i++) {
      if (decimalPart[i] === '0' && nonZeroFound) {
        limitDecimal = limitDecimal.slice(0, i - leadingZeros); // Si aparece otro cero, cortar
        break;
      }
      if (decimalPart[i] !== '0') {
        nonZeroFound = true; // Marca que ya encontramos un valor diferente a cero
      }
      if (limitDecimal.length >= 4) {
        break; // Limitar a 4 decimales
      }
      limitDecimal += decimalPart[i]; // Agregar más decimales
    }

    // Si hay ceros desplazados, resaltar esa cantidad
    if (leadingZeros > 0) {
      const formattedDecimal = `0<span className="text-xs relative -bottom-1">${leadingZeros}</span>${limitDecimal}`;
      return `${integerPart}.${formattedDecimal}`;
    }

    return valueString;
  };



  // Función para agrupar por fecha
  const groupByDate = (signals) => {
    return signals.reduce((acc, item) => {
      const date = new Date(item.date_start); // Asumimos que date_start es un string con la fecha
      const formattedDate = format(date, 'dd, MMMM yyyy'); // Formato deseado: 06, Enero 2025

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }

      acc[formattedDate].push(item); // Agrupamos el item por la fecha
      return acc;
    }, {});
  };

  // Agrupamos las señales
  const groupedSignals = groupByDate(signals);

  const oraculo = (props) => {
    if (window.localStorage.getItem("tron")) {
      let value = props / window.localStorage.getItem("tron");
      let fomart = Number.parseFloat(value).toFixed(3);
      let valueFormat = formatNumber(fomart);
      return valueFormat;
    }
  };

  const toggleDetail = (index) => {
    setDetailVisible((prev) => ({
      ...prev,
      [index]: !prev[index]
    }))
  }

  const copyWallet = (token) => {
    navigator.clipboard.writeText(
      `${token}`
    );
    toast.success(t("_DASHBOARD._COPYMESSAGE"));
  };


  return (
    <div>
      <div className="flex flex-col lg:flex-row lg:justify-between w-3/4 lg:w-full gap-3">
        <h1 className="text-white text-3xl"></h1>
        <LanguageAndNotificacions />
      </div>
      <div className="bg-black/90 p-4 rounded-lg lg:my-2">
        <div className="flex justify-center" >
          <img src={EllipseGreen} alt="Ellipse Orange" className="z-10 absolute w-4/12 -top-40 opacity-50" />
          <img src={CTFSignalsLogo} alt="CTFLIX" className="z-10" />
        </div>
        <div className=" p-2 text-white">
          <div className="flex flex-col lg:flex-row gap-4">
            <div className="bg-black-800 text-white p-6 rounded-lg w-full lg:w-2/6 border-zinc-600 border-2 h-2/5">
              <h2 className="text-3xl font-semibold mb-2 text-center">{t("_FREE._LINK")}</h2>
              <p className="text-center text-md mb-4">{t("_FREE._TITLE")}</p>
              <div className="flex flex-col justify-center items-center w-full my-2">
                <QRCode
                  size={256}
                  fgColor={"#bef264"}
                  level={"L"}
                  bgColor={"#ffffff00"}
                  value={"https://chat.whatsapp.com/I40EzQSOmeW6XBAD3NRkQC"}
                  className={"w-4/6 p-2 rounded-lg"}
                  viewBox={`0 0 256 256`}
                />
                <a href="https://chat.whatsapp.com/I40EzQSOmeW6XBAD3NRkQC" target={"_blank"} rel="noreferrer" >
                  <button className="bg-black text-blue-300 p-2 px-8 rounded-3xl my-2 border-lime-300 border-2 shadow-xl shadow-lime-300/50" >{t("_FREE._CHANNEL")}</button>
                </a>
              </div>
              <div className="my-8">
                <h5 className="my-2">{t("_FREE._DISCLAIMER")} </h5>
                <p className="text-sm">{t("_FREE._TEXTDISCLAIMER")} </p>
                <ul className="grid grid-cols-1 lg:grid-cols-2 gap-6 my-4">
                  <li className="flex flex-row items-center col-span-1 text-xs">
                    <img src={SignalsICO} alt={"Icon Signals"} /> {t("_FREE._NAME")}
                  </li>
                  <li className="flex flex-row items-center col-span-1  text-xs">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 mx-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                    </svg>
                    {t("_FREE._URL")}
                  </li>
                  <li className="flex flex-row items-center col-span-1  text-xs">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 mx-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    {t("_FREE._START")}
                  </li>
                  <li className="flex flex-row items-center col-span-1  text-xs">
                    <span className="size-6 mx-6 text-xl">{" "}%</span>
                    {t("_FREE._PROFIT")}
                  </li>
                  <li className="flex flex-row items-center col-span-1  text-xs">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 mx-6 rotate-180">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    {t("_FREE._END")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="w-full lg:w-4/6">
              <div className="mb-4 w-full">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
                  {signals.map((item, index) => (
                    <div
                      className="w-full z-20 rounded-lg text-white flex flex-col mb-4 relative hover:border-lime-300 hover:border-2 hover:shadow-xl hover:shadow-lime-300/50 h-min-40"
                      key={index}
                    >
                      <div
                        className={`absolute -top-4 -right-2 ${item?.status === "0" ? "bg-green-600 " : "bg-red-600 "}  text-white text-xs font-bold py-1 px-2 rounded-full shadow-lg `}
                      >
                        {item?.status === "0" ? t("_SIGNAL._OPEN") : t("_SIGNAL._CLOSED")}
                      </div>
                      <div className={`absolute -top-4 -left-2 bg-blue-600 text-white text-xs font-bold py-1 px-2 rounded-full shadow-lg `}>
                        {item?.created && new Date(item?.created).toDateString()}
                      </div>
                      <div className="h-auto flex flex-col  w-full group bg-zinc-800 rounded-lg shadow-md">
                        <img
                          src={item?.header}
                          alt={item?.name}
                          className="rounded-lg"
                        />
                        <div className="rounded-lg px-2 flex flex-col lg:flex-row justify-between">
                          <div className="flex text-white flex-row items-center justify-center">
                            <img src={SignalsICO} alt={"Icon Signals"} />
                            <h3 className="uppercase text-sm">{item?.name}</h3>
                          </div>
                          <div className="flex text-white flex-row items-center justify-center">
                            <button className="flex gap-2 flex-row rounded-2xl m-2 border-2 border-[#383838] p-2" onClick={() => toggleChat(item)}>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z" />
                              </svg>
                            </button>
                            <a
                              href={`https://signals.cryptoxperience.io/dashboard/${item?.token}/${item?.symbol}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <button className="flex gap-2 flex-row rounded-2xl m-2 border-2 border-[#383838] p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                                </svg>
                                {t("_FREE._VER")}
                              </button>
                            </a>
                            <button
                              className="flex gap-2 flex-row rounded-2xl m-2 border-2 border-[#383838] p-2"
                              onClick={() => toggleDetail(index)}
                            >
                              🔍
                            </button>
                          </div>
                        </div>
                        <div className="rounded-lg px-2 flex flex-col lg:flex-row  text-white justify-center items-center my-4 gap-2 lg:gap-0">
                          {detailVisible[index] ? (
                            <div className="flex flex-col gap-2 text-center">
                              <div className="text-sm">🧠 <strong>{item?.name}</strong></div>
                              <div className="text-sm flex gap-2 justify-center items-center cursor-pointer" onClick={() => copyWallet(item?.token)}>🪙
                                <strong>
                                  {item?.token ? item?.token.slice(0, 6) + "......" + item?.token.slice(-6) : "Loading"}
                                </strong>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z" />
                                </svg>
                              </div>
                              <div className="text-sm">💰{t("_SIGNAL._INITIAL")}: <strong>{item?.marketCap ?? '—'} {t("_SIGNAL._MKCAP")}</strong></div>
                              <div className="text-sm">💰{t("_SIGNAL._MAXIMUN")}: <strong>{item?.ath_record ?? '—'} {t("_SIGNAL._MKCAP")}</strong></div>
                              <div className="text-sm">🗓️{t("_SIGNAL._DATEATH")}: <strong>{item?.ath_date ?? '—'} </strong></div>
                            </div>
                          ) : (
                            <>
                              <button className="flex gap-2 flex-row rounded-2xl border-2 border-lime-300 group-hover:border-lime-300 p-2 justify-center items-center text-xs w-full lg:w-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                                {item?.date_start && new Date(item?.date_start).toLocaleTimeString()}
                              </button>
                              <hr className="h-px border border-indigo-300 w-10 hidden lg:block"></hr>
                              {parseInt(item?.status) === 0 ? (
                                <>
                                  {parseInt(item?.profit) > 0 && (
                                    <>
                                      <button className="flex justify-center  gap-2 flex-row rounded-2xl border-2 border-[#383838] p-2 px-4 border-2 border-lime-300 group-hover:border-lime-300 w-full lg:w-auto" >
                                        {item?.profit}%
                                      </button>
                                      <hr className="h-px border border-indigo-300 w-10 hidden lg:block"></hr>
                                    </>
                                  )}
                                  <button className="rounded-2xl border-2 border-[#383838] p-2 px-4 border-2 border-lime-300 group-hover:border-lime-300  text-xs w-full lg:w-auto" dangerouslySetInnerHTML={{ __html: t("_SIGNAL._PRICEENTRY") + " " + item?.priceUsd + " USD" }} />
                                </>
                              ) : (
                                <>
                                  <button className="flex gap-2 justify-center flex-row rounded-2xl border-2 border-[#383838] p-2 px-4 border-2 border-lime-300 group-hover:border-lime-300 w-full lg:w-auto" >
                                    {item?.profit}%
                                  </button>
                                  <hr className="h-px border border-indigo-300 w-10 hidden lg:block"></hr>
                                  <button className="flex gap-2 flex-row rounded-2xl border-2 border-[#383838] p-2 px-4 border-2 border-lime-300 group-hover:border-lime-300 text-xs w-full lg:w-auto">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 rotate-180">
                                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                    </svg>
                                    {item?.date_end && new Date(item?.date_end).toLocaleTimeString()}
                                  </button>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex justify-center mt-6 gap-2">
                  {Array.from({ length: Math.ceil(total / limit) }, (_, i) => (
                    <button
                      key={i}
                      className={`px-3 py-1 rounded-full border text-sm ${i + 1 === page ? 'bg-lime-500 text-white' : 'bg-zinc-700 text-gray-300'
                        }`}
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Chat isOpen={isChatOpen} toggleChat={toggleChat} information={data} />
    </div>
  );
}
